import React, { useState } from 'react';
import ImageViewer from './ImageViewer';
import { COLORS } from '../../styles/tokens';

// Bilder bestiller la ved oppdraget (adkomst, lasteplass). Vises for sjåfør, transportør, admin og bestiller.
export default function OrdererPhotos({ order }) {
  const [viewer, setViewer] = useState(null);
  const urls = Array.isArray(order?.ordererPhotoUrls) ? order.ordererPhotoUrls : [];
  if (urls.length === 0) return null;
  return (
    <div style={{ marginTop: 8 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.textMid, marginBottom: 6 }}>Bilder fra bestiller</div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {urls.map((url, i) => (
          <button
            key={url}
            type="button"
            aria-label={`Åpne bilde ${i + 1}`}
            onClick={() => setViewer({ url, label: `Bilde fra bestiller ${i + 1}` })}
            style={{ padding: 0, border: `1px solid ${COLORS.border}`, borderRadius: 10, overflow: 'hidden', cursor: 'pointer', background: COLORS.white }}
          >
            <img src={url} alt="" style={{ width: 72, height: 72, objectFit: 'cover', display: 'block' }} />
          </button>
        ))}
      </div>
      {viewer && <ImageViewer {...viewer} onClose={() => setViewer(null)} />}
    </div>
  );
}
